import React from "react";
import PhoenixFormInstance from "../PhoenixFormInstance";

interface Props {
  pnxFormId: string;
  isAnonymous?: boolean;
  showFormNameHeader?: boolean;
}

// very simple control, possibly not needed. but i already made it and i like the idea of all of the previews using a shared control in case we change how previews work
// feel free to just remove this if we never really need it down the line
const PhoenixFormPreview = ({ pnxFormId, isAnonymous = false, showFormNameHeader = false }: Props) => <PhoenixFormInstance form={{ previewFormId: pnxFormId, isAnonymousPreview: isAnonymous }} readonly={false} showFormNameHeader={showFormNameHeader} />;

export default PhoenixFormPreview;
